import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    user: null,
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUser(state, user) {
      state.user = user;
    },
    removeToken(state) {
      state.token = null;
    },
    removeUser(state) {
      state.user = null;
    },
  },
  actions: {
    // Implemente ações para fazer login, logout, etc.
  },
  plugins: [
    store => {
      // Carregue o estado do localStorage, se existir
      const localState = JSON.parse(localStorage.getItem('vuex_state'));
      if (localState) {
        store.replaceState({ ...store.state, ...localState });
      }

      // Salve o estado no localStorage sempre que ele for alterado
      store.subscribe((mutation, state) => {
        localStorage.setItem('vuex_state', JSON.stringify(state));
      });
    },
  ],
});
